export const creditReason = {
	shortSupply: "Short supply",
	damagedAndRejected: "Damaged and rejected",
	concealedDamage: "Concealed damage",
	crackedPanel: "Cracked panel",
};
export const creditStatus = {
	draft: "Draft",
	inProgress: "InProgress",
	awaitingSupplier: "AwaitingSupplier",
	pendingReview: "PendingReview",
	reviewing: "Reviewing",
	cancelled: "Cancelled",
	claimed: "Claimed",
};
